import React from "react";
import { motion } from "framer-motion";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ThemeToggle from "./ThemeToggle";
import ResumePDF from "./ResumePDF";
import { assetUrl, photoOrAvatar } from "../lib/assets";

export default function Header({ data }) {
  const photoSrc = assetUrl("/assets/Self_no_bg.png"); // public path

  return (
    <header className="relative rounded-2xl overflow-hidden shadow-md ring-1 ring-slate-200/70 dark:ring-slate-700 bg-slate-50 dark:bg-slate-900">
      <div className="absolute top-3 right-3 no-print">
        <ThemeToggle variant="icon" />
      </div>

      <motion.div className="w-full bg-[#A7C7E7] dark:bg-slate-700 h-2" layoutId="topbar" />

      <div className="px-6 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <div className="flex-1">
          <h1 className="text-4xl font-bold tracking-tight text-[#1E3A8A]">{data.name}</h1>
          <p className="mt-1 text-slate-700 dark:text-slate-300 text-[16px]">{data.headline}</p>

          <div className="mt-4 flex flex-wrap items-center gap-x-6 gap-y-1 text-sm text-slate-700 dark:text-slate-300">
            <span>{data.location}</span>
            <a
              className="underline text-[#1E3A8A] dark:text-[#A7C7E7] hover:text-[#2563EB] dark:hover:text-sky-300 focus:outline-none focus:ring-2 focus:ring-[#A7C7E7] rounded"
              href={`mailto:${data.email}`}
            >
              {data.email}
            </a>
            <a href={`tel:${data.phone.replace(/-/g, "")}`} className="text-inherit no-underline">{data.phone}</a>
            <a
              className="underline text-[#1E3A8A] dark:text-[#A7C7E7] hover:text-[#2563EB] dark:hover:text-sky-300 focus:outline-none focus:ring-2 focus:ring-[#A7C7E7] rounded"
              href={data.linkedin}
            >
              <span className="print-hide">LinkedIn</span>
              <span className="print-show">{data.linkedin.replace("https://www.", "")}</span>
            </a>

            <PDFDownloadLink
              document={<ResumePDF data={data} />}
              fileName="Steven_Li_Resume.pdf"
              className="ml-auto no-print inline-flex items-center gap-2 border border-[#A7C7E7] bg-[#F4F8FF] dark:bg-slate-900 text-[#1E3A8A] dark:text-[#A7C7E7] px-3 py-1.5 rounded-md text-sm hover:bg-[#E9F1FF] dark:hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-[#A7C7E7]"
            >
              {({ loading }) => (loading ? "Preparing PDF…" : "Download Resume")}
            </PDFDownloadLink>
          </div>
        </div>

        <motion.div
          className="shrink-0 self-start md:self-center no-print"
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          {photoOrAvatar({
            src: photoSrc,
            name: data.name,
            className:
              "no-export w-28 h-28 md:w-32 md:h-32 object-contain rounded-full bg-slate-50 dark:bg-slate-800 shadow ring-1 ring-slate-200 dark:ring-slate-700 select-none",
          })}
        </motion.div>
      </div>
    </header>
  );
}
